import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../Interceptor/interceptor";


export const contactApi = createApi({
    reducerPath: 'contactApi',
    baseQuery: baseApiQuery,
    tagTypes: ["posts"],
    endpoints: (builder) => ({
        contact: builder.mutation({
            query: (user) => ({
                url: 'wh/customer/enquiry/',
                method: 'POST',
                body: user,
            })
        }),
    })
})

export const { useContactMutation } = contactApi